/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AreaListResponse } from '../../models/area-list-response';

export interface GetAllAreas$Params {

/**
 * Find area by zip code
 */
  zip_code?: number;
}

export function getAllAreas(http: HttpClient, rootUrl: string, params?: GetAllAreas$Params, context?: HttpContext): Observable<StrictHttpResponse<AreaListResponse>> {
  const rb = new RequestBuilder(rootUrl, getAllAreas.PATH, 'get');
  if (params) {
    rb.query('zip_code', params.zip_code, {"style":"form","explode":true});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AreaListResponse>;
    })
  );
}

getAllAreas.PATH = '/api/v1/areas';
